import { cohortBuilderEmptyStateCardMessagesEn } from './cohort-builder-cards/cohortBuilderEmptyStateCardMessagesEn';
import { cohortBuilderSqlContentMessagesEn } from './cohort-builder-cards/cohortBuilderSqlContentMessagesEn';
import { cohortBuilderTranslationCopyMessagesEn } from './cohort-builder-cards/cohortBuilderTranslationCopyMessagesEn';
import { cohortBuilderViewCardMessagesEn } from './cohort-builder-cards/cohortBuilderViewCardMessagesEn';
import { analyticalVariableLibraryMessagesEn } from './cohort-section-messages/analyticalVariableLibraryMessagesEn';
import { cohortBuilderHeaderMessagesEn } from './cohort-section-messages/cohortBuilderHeaderMessagesEn';
import { criteriaSectionMessagesEn } from './cohort-section-messages/criteriaSectionMessagesEn';
import { derivedEventsSectionMessagesEn } from './cohort-section-messages/derivedEventsSectionMessagesEn';
import { dslTranslationsSectionMessagesEn } from './cohort-section-messages/dslTranslationsSectionMessagesEn';
import { indexDateSectionMessagesEn } from './cohort-section-messages/indexDateSectionMessagesEn';
import { researchAssistantSectionMessageEn } from './cohort-section-messages/researchAssistantSectionMessageEn';
import { simpleEventsSectionMessageEn } from './cohort-section-messages/simpleEventsSectionMessageEn';
import { studyPeriodSectionMessagesEn } from './cohort-section-messages/studyPeriodSectionMessagesEn';
import { subjectVariablesSectionMessagesEn } from './cohort-section-messages/subjectVariablesSectionMessagesEn';
import { cohortBuilderInfoBarMessagesEn } from './components/cohortBuilderInfoBarMessagesEn';
import { eventDrillDownPageHeaderMessagesEn } from './components/eventDrillDownPageHeaderEn';
import { eventDataTableMessagesEn } from '../containers/v0/cohort-builder-page-tabs/EventDrillDownPage/components/EventDataTableSection/eventDataTableMessagesEn';
import { eventDistributionMessagesEn } from '../containers/v0/cohort-builder-page-tabs/EventDrillDownPage/components/EventDistributionSection/eventDistributionMessagesEn';
import { processingOverlayMessagesEn } from '../containers/v0/cohort-builder-page-tabs/EventDrillDownPage/components/ProcessingOverlay/processingOverlayMessagesEn';

export default {
  ...cohortBuilderHeaderMessagesEn,

  ...cohortBuilderEmptyStateCardMessagesEn,
  ...cohortBuilderViewCardMessagesEn,
  ...cohortBuilderSqlContentMessagesEn,
  ...cohortBuilderTranslationCopyMessagesEn,

  ...simpleEventsSectionMessageEn,
  ...derivedEventsSectionMessagesEn,

  ...studyPeriodSectionMessagesEn,
  ...indexDateSectionMessagesEn,
  ...subjectVariablesSectionMessagesEn,
  ...criteriaSectionMessagesEn,
  ...dslTranslationsSectionMessagesEn,

  ...cohortBuilderInfoBarMessagesEn,
  ...eventDrillDownPageHeaderMessagesEn,
  ...eventDataTableMessagesEn,
  ...eventDistributionMessagesEn,
  ...processingOverlayMessagesEn,

  ...researchAssistantSectionMessageEn,
  ...analyticalVariableLibraryMessagesEn,
};
